const getDataFieldsTree = () => {
  return [
    {
      title: "Boxes",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Sub Boxes",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

export { getDataFieldsTree };

const getCustomizationFieldTree = () => {
  return [
    // {
    //   title: "Bar Size",
    //   type: "range",
    //   defaultValue: "30",
    //   minValue: 0,
    //   maxValue: 100,
    //   reduxKey: "barsize",
    //   itemInArray: false,
    // },
    //color type select
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Transparency",
      type: "range",
      defaultValue: 90,
      minValue: 20,
      maxValue: 100,
      reduxKey: "transparency",
    },

    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Font Size",
          type: "range",
          defaultValue: 15,
          minValue: 12,
          maxValue: 40,
          reduxKey: "labelFontSize",
          isParent: true,
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },

            // { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },
      ],
    },
  ];
};

export { getCustomizationFieldTree };
